















































import { Component, Mixins } from "vue-property-decorator";
import { RequestsModule } from "@/store/requests.module";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";
import VCleaveInput from "vuetify-cleave";
import moment from "moment";
import { ReqPlan } from "~/requests.type";
import SignRequest from "@/components/ui/SignRequest.vue";
import { BaseModule } from "@/store/base.module";

@Component({ components: { VCleaveInput, SignRequest } })
export default class NewContract extends Mixins(FormValidator) {
  formRef = "formPlan";
  loading: boolean = false;
  ReadOnly: boolean = false;

  get list() {
    return RequestsModule.planList;
  }

  set list(val) {
    RequestsModule.setPlan(val);
  }

  get user() {
    return AuthModule.user as IUser;
  }

  getMonthName(item: ReqPlan) {
    moment.locale(this.$i18n.locale);
    return moment(item.month, "M").format("MMMM") + " " + item.year.toString();
  }

  async savePlan() {
    if (!this.validateForm()) return;
    try {
      this.loading = true;
      await RequestsModule.addEditPlan({
        record_id: Number.parseInt(this.$route.params.id),
        params: this.list,
      });

      BaseModule.showMessage({
        message: "requests.plan_saved",
        color: "success",
      });

      this.$router.push("/contracts");
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    RequestsModule.setPlan([]);
    //this.resetFormValidation();
    const id = this.$route.params.id;
    if (id) {
      // this.ReadOnly =
      //   RequestsModule.SelectedItem && !RequestsModule.SelectedItem.can_suppl;
      RequestsModule.getRequestPlan(Number.parseInt(id));
    } else this.$router.push("/contracts");
  }
}
